import React from 'react';

import FadeIn from 'src/components/elements/FadeIn';

import { S3_MP4_URL } from '../../../../constants';

import styles from '../../CircleBlock.scss';

const SecondCircle = () => (
  <div id="circle-2" className={styles.circleBlock}>
    <div className={styles.content} id="circle-2-title">
      <div className={styles.secondTitle}>
        <FadeIn className={styles.title} animationRepeat>
          <span className={styles.titleThin}>Masterpieces by</span>
        </FadeIn>
        <FadeIn className={styles.title} delay={1} animationRepeat>
          <span>Human-AI united</span>
        </FadeIn>
        <FadeIn className={styles.title} delay={1.5} animationRepeat>
          intelligence
        </FadeIn>
      </div>
      <FadeIn className={styles.description} delay={2} animationRepeat>
        <span>
          The duo of genuine minds and AI generate
          <br />
          exceptional Planet rewards
          <br />
          according to your unique travel activity
        </span>
      </FadeIn>
    </div>

    <video autoPlay preload="auto" loop muted playsInline className={styles.acidicCircle}>
      <source src={`${S3_MP4_URL}acidic_circle.mp4`} type="video/mp4" />
    </video>
  </div>
);

export default SecondCircle;
